// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"818bc56f","453":"7ffd7a88","553":"13a1caa7"}[chunkId] + ".chunk.js";
};